export class TogglePilotPanel {
   public static readonly type = '[PilotPanel] toggle panel';
}

export class PilotPanelExtendedChangedByServerAction {
   public static readonly type = '[Pilot Panel] PilotPanelExtendedChangedByServer';

   constructor(public isPilotPanelExtended: boolean) {}
}
